import React from 'react';

import {Box, LinearProgress, CircularProgress} from '@mui/material/';

const ProgressBar = () => {
    return (
        <Box sx={{ mt:'50px', width:'100%' }}>
            <LinearProgress />
        </Box>
    );
}

export default ProgressBar;
